import { useTranslation } from 'libs/translations';

export function useAutoshipCancellationI18n() {
  const { t } = useTranslation();

  const translateCancelationReason = (cancellationReasonID: number) => {
    switch (cancellationReasonID) {
      case 1:
        return t('I still have enough leftovers');
      case 2:
        return t("I don't feel I need it anymore");
      case 3:
        return t("It's too expensive for me");
      case 4:
        return t("I'd rather order without a subscription");
      case 100:
        return t('Autoship cancelled by return of the goods');
      case 101:
        return t('Termination of TP Contract');
      case 102:
        return t('Unsuccessful Payment');
      case 106:
        return t('Waiting for delivery address validation');
      case 107:
        return t('Customer has registered as a TP and created new ABO');
      // on purpose we're ignoring these two cases, keepeing them commented for awareness
      // case 104:
      // return t('Autoship takeover to other mandator');
      // case 105:
      // return t('Wait for product clarification');
      default: // also explicitly case 9
        return undefined;
    }
  };

  return translateCancelationReason;
}
